import Layout from '../components/Layout';
import AboutMeComponent from '../UI-Components/AboutMeComponent/AboutMeComponent';
import ProfileHeader from '../UI-Components/ProfileHeader/ProfileHeader';
import '../css/ProfilePageFirst.css';
import { UserContext } from '../context/UserContext';
import React, { useContext } from 'react';

// ProfilePage now uses userInfo from UserContext instead of making a separate Firestore call
// This eliminates redundant database reads and improves load time
const ProfilePage = () => {
  // userInfo is already fetched and cached in UserContext on auth state change
  const { userInfo } = useContext(UserContext);

  return (
    <div style={{ backgroundColor: '#F6F6F9', minHeight: '100vh' }}>
      <Layout pageTitle="My Profile">
        <div className="rounded-component-header" style={{ marginBottom: '30px' }}>
          <ProfileHeader userInfo={userInfo}>
          </ProfileHeader>
        </div>
        <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <AboutMeComponent userInfo={userInfo}>
          </AboutMeComponent>
        </div>
        {/* todo add later, not needed for now */}
        {/* <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <PhotosComponent>
          </PhotosComponent>
        </div>
        <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <MostLikedComponent>
          </MostLikedComponent>
        </div>
        <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <VideosComponent>
          </VideosComponent>
        </div> */}
      </Layout>
    </div>
  );
};

export default ProfilePage;